export default __webpack_public_path__ + "static/media/Pia_Dandiya.00845f10.jpg";